export enum COMPANIES {
  FORTOP = 'FORTOP',
  ASEFOR = 'ASEFOR',
  FINSA = 'FINSA',
  GEOMATICO = 'GEOMATICO',
  UVIGO = 'UVIGO',
  UTG = 'UTG',
}

export const ADMIN_COMPANIES = [COMPANIES.ASEFOR, COMPANIES.GEOMATICO];

export type User = {
  uuid: string;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  organization: COMPANIES;
  created_at: string;
  updated_at: string;
};
